module.exports = __webpack_public_path__ + "img/repair-black.a8e7b65e.svg";